import { booleanParser, numberArrayParser } from '../inboundParsers';
import { lastActionParser } from './utils/lastActionInboundUtils';
import { seatIndexesParser } from './utils/pokerInboundUtils';
export const DISCARD_PHASE_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'isMyDiscardTurn', parser: booleanParser },
        { name: 'discardSeatIndexesRemaining', parser: seatIndexesParser },
        { name: 'lastAction', parser: lastActionParser },
        { name: 'potAmounts', parser: numberArrayParser }
    ]
};
